import { ThemeBlueprint } from "@backstage/plugin-app-react";
import { UnifiedThemeProvider } from "@backstage/theme";
import { exxThemeLight, exxThemeDark } from "./ExxTheme";

export const exxLightTheme = ThemeBlueprint.make({
    name: 'exx-light',
    params: {
        theme: {
            id: 'exx-theme-light',
            title: 'eXXcellent light',
            variant: 'light',
            Provider: ({ children }) => <UnifiedThemeProvider theme={exxThemeLight} children={children} />,
        },
    },
});

export const exxDarkTheme = ThemeBlueprint.make({
    name: 'exx-dark',
    params: {
        theme: {
            id: 'exx-theme-dark',
            title: 'eXXcellent dark',
            variant: 'dark',
            Provider: ({ children }) => <UnifiedThemeProvider theme={exxThemeDark} children={children} />,
        },
    },
});